import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { UtilsService } from 'src/app/core/service/utils.service';
import { FileModel } from 'src/app/pages/project-request/models/file.model';

@Component({
  selector: 'app-whiteboard',
  templateUrl: './whiteboard.component.html',
  styleUrls: ['./whiteboard.component.scss']
})
export class WhiteboardComponent implements OnInit, AfterViewInit {

  @ViewChild("iframe", { static: true }) iframe: ElementRef;
  @ViewChild("image") image: ElementRef;
  @ViewChild("canvas") canvas: ElementRef;
  @Input('file') file: FileModel | null = null;
  @Output() save: EventEmitter<any> = new EventEmitter();

  name: string | null = null;
  editor: string = 'https://embed.diagrams.net/?embed=1&ui=atlas&spin=1&proto=json';
  projectId: number | null = null;

  constructor(protected translate: TranslateService,
    protected activeRoute: ActivatedRoute,
    protected utilSrv: UtilsService) {
    this.projectId = this.activeRoute.snapshot.params.projectId;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.edit();
  }

  edit() {
    this.iframe.nativeElement.frameborder = 0;

    let draft: any = localStorage.getItem('.draft-' + (this.projectId ? this.projectId : this.name));
    // console.warn('Draft', draft);
    if (draft != null) {
      draft = JSON.parse(draft);

      // "A version of this page from " + new Date(draft!.lastModified).toDateString() + " is available. Would you like to continue editing?"
      const question = `${this.translate.instant('ARTIFACT.BOARD.INFO')} ${moment(draft!.lastModified).format('YYYY-MM-DD HH:mm')}! ${this.translate.instant('ARTIFACT.BOARD.QUESTION')}`;

      this.utilSrv.confirm(question).then((resp: any) => {
        if (resp.isDismissed) {
          localStorage.removeItem('.draft-' + this.name);
          draft = null;
        }
      })
    }

    const receive = (evt: { data: string }) => {
      const obj: any = this;

      if (evt.data.length > 0) {
        var msg = JSON.parse(evt.data);

        if (msg.event == 'init') {
          if (draft != null) {
            this.iframe.nativeElement.contentWindow.postMessage(JSON.stringify({
              action: 'load',
              autosave: 1,
              xml: draft.xml
            }), '*');
            this.iframe.nativeElement.contentWindow.postMessage(JSON.stringify({
              action: 'status',
              modified: true
            }), '*');
          } else if (this.file !== null) {
            this.getBase64FromUrl(this.file.url).then((base64: any) => {
              // console.warn('Base64', base64);
              this.iframe.nativeElement.contentWindow.postMessage(JSON.stringify({
                action: 'load',
                autosave: 1,
                xmlpng: base64
              }), '*');
            });
          } else {
            this.iframe.nativeElement.contentWindow.postMessage(JSON.stringify({
              action: 'load',
              autosave: 1
            }), '*');
          }
        }
        else if (msg.event == 'export') {
          // image.setAttribute('src', msg.data);
          this.save.emit(msg.data);
          localStorage.setItem(this.projectId ? this.projectId.toString() : obj.name, JSON.stringify({ lastModified: new Date(), data: msg.data }));
          localStorage.removeItem('.draft-' + (this.projectId ? this.projectId.toString() : obj.name));
          draft = null;
          close();
        } else if (msg.event == 'autosave') {
          localStorage.setItem('.draft-' + (this.projectId ? this.projectId.toString() : obj.name), JSON.stringify({ lastModified: new Date(), xml: msg.xml }));
        } else if (msg.event == 'save') {
          this.iframe.nativeElement.contentWindow.postMessage(JSON.stringify({
            action: 'export',
            format: 'xmlpng', xml: msg.xml, spin: 'Updating page'
          }), '*');
          localStorage.setItem('.draft-' + (this.projectId ? this.projectId.toString() : obj.name), JSON.stringify({ lastModified: new Date(), xml: msg.xml }));
        } else if (msg.event == 'exit') {
          localStorage.removeItem('.draft-' + (this.projectId ? this.projectId.toString() : obj.name));
          draft = null;
          close();
        }
      }
    };

    window.addEventListener('message', receive);
    this.iframe.nativeElement.src = this.editor;
    // document.getElementById('wrapperBoard')?.appendChild(this.iframe.nativeElement);
  };

  getBase64FromUrl = async (url: any) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }

}
